import { forwardRef, type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { Button } from '@highlight/ui'

interface PreviewPillButtonProps extends ComponentProps<typeof Button> {
  /**
   * Dashed reads as "unset" — a value the card invites you to fill in (Set due
   * date, Pin). Solid is a plain command or an already-set value.
   */
  outline?: 'dashed' | 'solid'
  /** Filled selected state, the pin button when the reminder is pinned. Drawn as `secondary`. */
  selected?: boolean
}

/** Footer button for the hover preview cards: Button's md squircle, outline at rest. */
export const PreviewPillButton = forwardRef<HTMLButtonElement, PreviewPillButtonProps>(function PreviewPillButton(
  { outline = 'solid', selected = false, className, onClick, ...props },
  ref,
) {
  return (
    <Button
      ref={ref}
      variant={selected ? 'secondary' : 'outline'}
      className={twMerge(
        // !px: hosts mount this as a Popover.Trigger render element, and the
        // trigger wrapper's own p-0 lands on the same node via string concat —
        // outside twMerge's reach — and wins the cascade.
        '!px-[var(--btn-pad)]',
        outline === 'dashed' && !selected && 'border-dashed',
        className,
      )}
      {...props}
      onClick={(event) => {
        // Nested popovers live inside a hover card; a bubble would look like
        // an outside press to the card and dismiss the menu as it opens.
        event.stopPropagation()
        onClick?.(event)
      }}
    />
  )
})
